import { FloorMapSpaces } from '@api'
import numeral from 'numeral'
import { Button } from '@runeffective/evo-design-system'
import { Flex } from '@ui'
import { metric, toSqm } from 'components/AdminFloorPlan/components/MeasurementInput/measurement'
import ChartSection from 'components/ChartSection'
import { getColor } from 'components/Reports/config'
import { get, groupBy, keys } from 'lodash'
import React, { useState } from 'react'

import typescriptNaturalSort from 'typescript-natural-sort'
import { useUser } from '@hooks'
import AreaSectionPopup from './areaSectionPopup'

const formatData = (spaces: any, selectedItems: string[], units: string) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )
  const grouped = groupBy(items, ({ measurements }) => measurements)
  return keys(grouped)
    .sort((k1, k2) => typescriptNaturalSort(k1, k2))
    .map((key, i) => {
      const xValue = metric(units) ? toSqm(Number(key)) : Number(key)
      const format = Number.isInteger(xValue) ? '0,0' : '0,0.00'
      return {
        key,
        color: `#${getColor(i)}`,
        units: units,
        xLabel: `Area(${units})`,
        x: numeral(xValue).format(format),
        y: grouped[key].length,
      }
    })
}

const AreaSection = ({
  spaces,
  selectedItems,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
}) => {
  const user = useUser()
  const unit = get(user, 'user.context.units', '')
  const chartData = formatData(spaces, selectedItems, unit)
  const [isAreaOpen, setIsAreaOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="bar" colName="" description="" data={chartData} unit={unit} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        <Button
          layout="secondary"
          onClick={() => {
            setIsAreaOpen(true)
          }}
          size="small"
        >
          Resize areas
        </Button>
      </Flex>

      <AreaSectionPopup
        setIsAreaeOpen={setIsAreaOpen}
        isAreaeOpen={isAreaOpen}
        selectedSpaces={selectedItems}
      />
    </div>
  )
}

export default AreaSection
